import type { useFloating, useInteractions } from '@floating-ui/react';

import { createContext, useContext } from 'react';

type Floating = ReturnType<typeof useFloating<HTMLElement>>;
type Interactions = ReturnType<typeof useInteractions>;

export type PopoverContextValue = {
  context: Floating['context'];
  floatingStyles: Floating['floatingStyles'];
  getFloatingProps: Interactions['getFloatingProps'];
  getReferenceProps: Interactions['getReferenceProps'];
  isOpen: boolean;
  /** Where `PopoverContent` portals to — an ancestor modal/popover's top
   * layer when open inside one, so the content isn't stacked behind its
   * host. `undefined` defaults to `document.body`. */
  portalRoot: HTMLElement | undefined;
  setFloating: Floating['refs']['setFloating'];
  setReference: Floating['refs']['setReference'];
};

export const PopoverContext = createContext<PopoverContextValue | null>(null);

export function usePopoverContext() {
  const context = useContext(PopoverContext);
  if (context == null) {
    throw new Error(
      'PopoverTrigger and PopoverContent must be used within Popover.',
    );
  }
  return context;
}
